import React from 'react';

// ===========================|| LIVE CUSTOMIZATION ||=========================== //

const Customization = () => <></>;

export default Customization;
